var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"rowClick":_vm.rowClickCallBack,"persistenceKey":'customer-list',"gcPopupCustomerStatementConfig":_vm.gcPopupCustomerStatementConfig,"loadDataGrid":_vm.loaded,"setLoading":_vm.setLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }